'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactSlidedown = require('react-slidedown');

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _TargetDateGrid = require('./TargetDateGrid.css');

var _TargetDateGrid2 = _interopRequireDefault(_TargetDateGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TargetDateGridItem = (_dec = (0, _reactCssModules2.default)(_TargetDateGrid2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TargetDateGridItem, _Component);

  function TargetDateGridItem(props) {
    (0, _classCallCheck3.default)(this, TargetDateGridItem);
    return (0, _possibleConstructorReturn3.default)(this, (TargetDateGridItem.__proto__ || (0, _getPrototypeOf2.default)(TargetDateGridItem)).call(this, props));
  }

  (0, _createClass3.default)(TargetDateGridItem, [{
    key: 'render',
    value: function render() {
      if (!this.props.targetDateSeries) {
        return null;
      }
      var targetDateSeries = this.props.targetDateSeries;

      var sName = _format2.default.sanitize(targetDateSeries.strategy_name);
      var sFamName = _format2.default.sanitize(targetDateSeries.fund_family_label);
      var url = _config2.default.routes.targetDateFunds + '/' + sName;

      // console.log('sFamName')
      // console.log(sFamName)

      var hasLogo = false;
      var logo = null;
      try {
        logo = require('../../../static/images/fam/' + sFamName + '.png');
        hasLogo = true;
      } catch (e) {
        console.log('');
      }

      var iconsEnv = {
        fff: require('../../../static/images/icons/fff-icon.svg'),
        dff: require('../../../static/images/icons/dff-icon.svg'),
        ffb: require('../../../static/images/icons/ffb-icon.svg'),
        ffi: require('../../../static/images/icons/ffi-icon.svg')
      };
      var iconsSoc = {
        gef: require('../../../static/images/icons/gef-icon.svg'),
        gff: require('../../../static/images/icons/gff-icon.svg'),
        pff: require('../../../static/images/icons/pff-icon.svg'),
        wff: require('../../../static/images/icons/wff-icon.svg'),
        tff: require('../../../static/images/icons/tff-icon.svg')
      };

      var redOctagon = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Poor', styleName: 'red-octagon' })
        )
      );

      var yellowSquare = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Fair', styleName: 'yellow-square' })
        )
      );

      var greenCircle = _react2.default.createElement(
        'div',
        { styleName: 'result-shape-txt-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'result-shape-wrap' },
          _react2.default.createElement('div', { title: 'Good', styleName: 'green-circle' })
        )
      );

      var shapeDecider = function shapeDecider(fund, key) {
        var grade_label = {
          fff: 'grade_fossil',
          dff: 'grade_deforestation',
          ffb: 'grade_fossil_bank',
          ffi: 'grade_fossil_insure',
          gef: 'grade_gender_equality',
          gff: 'grade_guns',
          pff: 'grade_prison_industrial_complex',
          wff: 'grade_military',
          tff: 'grade_tobacco'
        }[key];

        var grade = fund[grade_label];
        if (grade >= 4) {
          return redOctagon;
        } else if (grade >= 2) {
          return yellowSquare;
        } else if (grade === 1) {
          return greenCircle;
        }
        return null;
      };

      var strategy_name = targetDateSeries.strategy_name;

      strategy_name = strategy_name.slice(strategy_name.length - 7) === ' Series' ? strategy_name.slice(0, strategy_name.length - 7) : strategy_name;

      //
      return _react2.default.createElement(
        _reactFlexboxGrid.Col,
        { styleName: 'grid-item-wrap', xs: 12, sm: 12 },
        _react2.default.createElement(
          _components.Link,
          {
            to: url,
            title: strategy_name
          },
          _react2.default.createElement(
            'div',
            { styleName: 'grid-item-box' },
            _react2.default.createElement(
              'div',
              { styleName: 'box-title-wrap' },
              hasLogo ? _react2.default.createElement('img', {
                src: logo,
                alt: strategy_name,
                styleName: 'box-title-logo'
              }) : null,
              _react2.default.createElement(
                'div',
                { styleName: 'box-title' },
                strategy_name,
                targetDateSeries.sustainable_investment ? _react2.default.createElement(
                  'span',
                  { styleName: 'leaf' },
                  _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-leaf' })
                ) : null
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'box-subtitle' },
                targetDateSeries.fund_legal_name,
                targetDateSeries.ticker && targetDateSeries.ticker !== 'N' ? ' (' + targetDateSeries.ticker + ')' : null
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'scores-wrap' },
              _react2.default.createElement(
                'div',
                { styleName: 'scores-env' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'scores-label' },
                  'Environment'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'scores-flex' },
                  (0, _keys2.default)(iconsEnv).map(function (e, i) {
                    return _react2.default.createElement(
                      'div',
                      {
                        key: 'grid-item-' + sName + '-' + i,
                        styleName: 'scores-item'
                      },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'scores-img' },
                        _react2.default.createElement('img', {
                          src: iconsEnv[e],
                          alt: 'Tmp'
                        })
                      ),
                      _react2.default.createElement(
                        'div',
                        null,
                        shapeDecider(targetDateSeries, e)
                      )
                    );
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'scores-soc' },
                _react2.default.createElement(
                  'div',
                  { styleName: 'scores-label' },
                  'Social'
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'scores-flex' },
                  (0, _keys2.default)(iconsSoc).map(function (e, i) {
                    return _react2.default.createElement(
                      'div',
                      {
                        key: 'grid-item-' + sName + '-' + i,
                        styleName: 'scores-item'
                      },
                      _react2.default.createElement(
                        'div',
                        { styleName: 'scores-img' },
                        _react2.default.createElement('img', {
                          src: iconsSoc[e],
                          alt: 'Tmp'
                        })
                      ),
                      _react2.default.createElement(
                        'div',
                        null,
                        shapeDecider(targetDateSeries, e)
                      )
                    );
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);
  return TargetDateGridItem;
}(_react.Component), _class2.propTypes = {
  // the target date series object
  targetDateSeries: _react.PropTypes.object
}, _temp)) || _class);
var TargetDateGrid = (_dec2 = (0, _reactCssModules2.default)(_TargetDateGrid2.default), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(TargetDateGrid, _Component2);

  function TargetDateGrid(props) {
    (0, _classCallCheck3.default)(this, TargetDateGrid);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (TargetDateGrid.__proto__ || (0, _getPrototypeOf2.default)(TargetDateGrid)).call(this, props));

    _this2.state = {
      show: false
    };
    return _this2;
  }

  (0, _createClass3.default)(TargetDateGrid, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (!_config2.default.targetDateSeries) {
        return null;
      }

      var NUMBER_TO_ALWAYS_SHOW = 4;
      var targetDateSeriesList = [].concat(_config2.default.targetDateSeries);

      //
      if (this.props.page) {
        // IF THIS IS THE TARGET DATE PAGE
        return _react2.default.createElement(
          _components.ContainerDivs,
          null,
          _react2.default.createElement('div', { styleName: 'grid-anchor', id: 'companies' }),
          _react2.default.createElement(
            'h1',
            { styleName: 'small-page-title' },
            'Target date funds'
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'grid-info' },
            'Target date funds are groups of funds, where each fund in the series targets a different mix of stocks and bonds for investors with different retirement time horizons. The default option in employer-offered retirement plans is often a target date fund series. Below are some of the largest target date fund series, rated using the 2050 fund.'
          ),
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'grid-boxes' },
            targetDateSeriesList.map(function (targetDateSeries, i) {
              return _react2.default.createElement(TargetDateGridItem, {
                key: 'target-date-grid-item-' + i,
                targetDateSeries: targetDateSeries
              });
            })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'content-wrap' },
            _react2.default.createElement(
              'h2',
              null,
              'How are these target date series chosen?'
            ),
            _react2.default.createElement(
              'p',
              null,
              'We think every target date fund series should be rated on sustainability. Our goal is to expand this database over the next year to cover all target date fund series offered by major asset managers. We started with these target date series because they are some of the largest and most commonly-owned target date funds on the market, with hundreds of billions in assets under management. Check back regularly to see if your target date fund series has been added to our database.'
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Want us to rate the target date fund series in your retirement plan? ',
                _react2.default.createElement(
                  _components.Link,
                  {
                    to: _config2.default.links.contact,
                    title: 'Contact us',
                    xstrong: true
                  },
                  'Get in touch with us',
                  _react2.default.createElement(_components.LinkIcon, null)
                )
              )
            )
          )
        );
      } else {
        // IF THIS IS THE HOME PAGE
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _reactFlexboxGrid.Row,
            { styleName: 'grid-boxes' },
            targetDateSeriesList.slice(0, NUMBER_TO_ALWAYS_SHOW).map(function (targetDateSeries, i) {
              return _react2.default.createElement(TargetDateGridItem, {
                key: 'target-date-grid-item-' + i,
                targetDateSeries: targetDateSeries
              });
            }),
            !this.state.show ? _react2.default.createElement(
              'div',
              { styleName: 'show-more-button-wrap' },
              _react2.default.createElement(
                'button',
                {
                  onClick: function onClick() {
                    _this3.setState({ show: !_this3.state.show });
                  },
                  title: 'Show more',
                  styleName: 'show-more-button'
                },
                'Show more',
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-angle-double-down' })
              )
            ) : null
          ),
          _react2.default.createElement(
            _reactSlidedown.SlideDown,
            null,
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              { styleName: 'grid-boxes' },
              this.state.show ? targetDateSeriesList.slice(NUMBER_TO_ALWAYS_SHOW, targetDateSeriesList.length).map(function (targetDateSeries, i) {
                return _react2.default.createElement(TargetDateGridItem, {
                  key: 'target-date-grid-item-' + (i + 3),
                  targetDateSeries: targetDateSeries
                });
              }) : null
            )
          )
        );
      }
    }
  }]);
  return TargetDateGrid;
}(_react.Component), _class4.propTypes = {
  // bool for page extras or no
  page: _react.PropTypes.bool
}, _temp2)) || _class3);
exports.default = TargetDateGrid;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TargetDateGrid/TargetDateGrid.js
// module id = 1443
// module chunks = 0